export const RESPONSE_CODES: Record<string, string> = {
    USER_NOT_FOUND: 'User not found',
    NO_ENTERPRISE_USER_WITH_THIS_EMAIL: 'There is no user registered with this email.',
    INCORRECT_PASSWORD: 'Incorrect email or password.',
    EMAIL_ALREADY_IN_USE: 'There is already a registered user with this email.',
    NO_USER_WITH_THIS_EMAIL: 'There is no user registered with this email.',
    CUSTOMER_ALREADY_REGISTERED: 'This customer already received a invitation.',
    INVITATION_NOT_FOUND: `It’s possible that your invitation link has expired, was already used, or was entered incorrectly.\nPlease check your link and try again or contact our support team for assistance. We’re here to help you get onboarded smoothly! Need help? support@pomsafe.com # (518)-720-7970 `,
    INVITATION_EXPIRED: "Your invitation has been expired",
    INVALID_TEMP_PASSWORD: "That temporary password doesn't match. Check the invitation email we sent you and try again.",
    OWNER_NOT_FOUND: "We're having trouble completing your onboarding. Please contact support@pomsafe.com and we'll get you set up.",
    UNKNOWN: 'An unknown error occurred when trying to perform the action.',
    INVITE_CODE_CHANGED: "Your invitation code has been changed",
    ALERT_RESOLVED: 'Alert resolved successfully.',
    ALERT_NOT_FOUND: 'Alert not found.',
    NO_PERMISSION: `You don't have permission to perform that action`,
    COGNITO_INVALID_SESSION: 'Invalid sso session, try with another one.',
    USER_NOT_FOUND_WITH_COGNITO_SESSION: 'User not registered in sso and pom safe.',
    COGNITO_USER_NOT_FOUND: 'User enable in POM but not enabled in SSO provider, please contact support.',
    COGNITO_USER_DISABLED: 'User is disabled in SSO provider, please contact support.',
    CAMPAIGN_MESSAGE_ALREADY_CANCELLED: 'This message has already been cancelled.',
    CAMPAIGN_MESSAGE_ALREADY_SENT: 'This message has already been sent.',
    USER_NOT_ACTIVE: 'User is not active, try to contact your company administrator.',
    CANNOT_DEACTIVATE_YOURSELF: 'You cannot deactivate yourself.',
    USER_ALREADY_FINISHED_ONBOARD: 'User already finished onboarding.',
    NO_MAP_ERROR: 'Something went wrong while saving. Please review your changes and try again.',
    // NIST 800-63B password policy (C.1.5) — server-side validatePassword codes.
    PASSWORD_REQUIRED: 'Please enter a password.',
    PASSWORD_TOO_SHORT: 'Password must be at least 8 characters.',
    PASSWORD_TOO_LONG: 'Password must be at most 64 characters.',
    PASSWORD_INVALID_CHARACTERS: 'Password can only contain letters, numbers, spaces, and common symbols.',
    PASSWORD_COMPROMISED: 'This password has appeared in a known data breach. Please choose a different one.',
    PASSWORD_ALREADY_SET: 'Your password has already been set. Please use login or password recovery.',
    RECOVER_TOKEN_EXPIRED: 'Your password reset link has expired. Please request a new one.',
    RECOVER_TOKEN_NOT_FOUND: 'This password reset link is invalid. Please request a new one.',
    // Team/group/tag CRUD (native pom-2-api endpoints, pentest C.1.2)
    TEAM_CREATED: 'Team created successfully.',
    TEAM_UPDATED: 'Team updated successfully.',
    TEAM_GROUP_UPDATED: 'Team moved to the new group.',
    TEAM_DELETED: 'Team deleted successfully.',
    GROUP_CREATED: 'Group created successfully.',
    GROUP_UPDATED: 'Group updated successfully.',
    GROUP_RETRIEVED: 'Group retrieved successfully.',
    GROUP_DELETED: 'Group deleted successfully.',
    TAGS_RETRIEVED: 'Tags retrieved successfully.',
    TAG_CREATED: 'Tag created successfully.',
    TAG_DELETED: 'Tag deleted successfully.',
    INVALID_TEAM_ID: 'Invalid team ID.',
    INVALID_GROUP_ID: 'Invalid group ID.',
    INVALID_TAG_ID: 'Invalid tag ID.',
    INVALID_SUBSCRIPTION_ID: 'Invalid subscription.',
    INTERNAL_SERVER_ERROR: 'Something went wrong. Please try again.',
    TEAM_NOT_IN_SUBSCRIPTION: 'One or more selected teams do not belong to your organization.',
    TEAM_NOT_FOUND: 'Team not found.',
    GROUP_NOT_FOUND: 'Group not found.',
    TAG_NOT_FOUND: 'Tag not found.',
    TEAM_ALREADY_EXISTS: 'A team with this name already exists in that group.',
    GROUP_ALREADY_EXISTS: 'A group with this name already exists.',
    USER_NOT_IN_SUBSCRIPTION: 'One or more selected members do not belong to your organization.',
    LEADER_NOT_IN_SUBSCRIPTION: 'One or more selected leaders do not belong to your organization.',
    TAG_NOT_IN_SUBSCRIPTION: 'One or more selected tags do not belong to your organization.',
    LEADER_NOT_FOUND: 'One or more selected leaders could not be found.',
    // POM Master tooling (ClickUp 868m4vzj7 license count, 868m3frw9 masquerade guard)
    LICENSE_COUNT_CHANGED: 'License count updated.',
    SUBSCRIPTION_NOT_FOUND: 'Subscription not found.',
    USER_MUST_BE_POM_MASTER: 'Only a POM Master can perform this action.',
    MASQUARADE_USER_NOT_REGISTERED: 'This user has not completed their account setup yet. Masquerade becomes available after their first login. Use "Resend invite" if they need a new invitation.',
    IRA_SEARCH_HISTORY_DISABLED: 'Search history is not enabled for your organization.',
    INTAKE_RISK_ASSESSMENT_NOT_PERMITTED: 'You do not have access to intake risk assessments.',
    IRA_FLAG_COMMENT_LENGTH: 'Please describe the issue in 3 to 1000 characters.',
    IRA_FLAG_COMMENT_HAS_PATIENT_DETAILS: 'Please describe the issue without patient details.',
    IRA_FLAG_NOT_ALLOWED_WHILE_MASQUERADING: 'Reports to POM Support cannot be sent while masquerading.',
    IRA_FLAG_RATE_LIMITED: 'Too many reports to POM Support in the last hour. Please try again later or email support@pomsafe.com.',
    IRA_FLAG_RESOLVE_NOT_PERMITTED: 'Only POM Support can resolve reports.',
    IRA_FLAG_RESULT_UNREADABLE: "This result's details can't be decrypted, so it can't be reported here. Please email support@pomsafe.com with the date and time of the search (no patient details).",
};
